import script from "./FirstPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./FirstPage.vue?vue&type=script&lang=ts&setup=true"

import "./FirstPage.vue?vue&type=style&index=0&id=08abb5ea&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08abb5ea"]])

export default __exports__